var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.textClasses,style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.displayedValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }